<template>
  <div id="publishing-journal-add">
    <div class="ipub-h1 mar-b-30">{{editId?'Edit Question':'Add New Question'}}</div>
    <ipub-form ref="questionnaire-add-form-first"
               :model="params"
               :rules="rules">
      <!-- 问题类型 -->
      <ipub-form-item prop="type"
                      label="Question Type"
                      class="flex">
        <ipub-radio-group class="mar-b-10 mar-l-30"
                          @change="onInputRadioGroup"
                          v-model="params.type"
                          _label="label"
                          :options="questionTypeChoose" />
      </ipub-form-item>

      <!-- 问答 -->
      <ipub-form-item prop="questionContent"
                      label="Question">
        <ipub-input v-model.trim="params.questionContent"
                    placeholder="Question" />
      </ipub-form-item>
      <!-- 单选和多选 -->
      <ipub-form-item prop="answer"
                      label="Answer"
                      v-if="params.type !== 'QA'">
        <ipub-table :columns="columns"
                    :dataSource="dataSource"
                    :pagination="false"
                    draggable
                    @drag="setSort">
          <template v-slot:answerInput="{ record,index }">
            <ipub-input v-model.trim="record.answer"
                        style="width:100%"
                        placeholder="Enter your answer here"
                        @blur="handleInputChange(record,index)" />
          </template>
          <template v-slot:actions="{ record, index }">
            <template>
              <ipub-tooltip v-if="params.type === 'SINGLE'"
                            class="border-right">
                <div slot="title">Edit</div>
                <ipub-icon type="iconEdit"
                           @click="edit(record, index)" />
              </ipub-tooltip>
              <ipub-icon v-else
                         class="disabled-icon"
                         type="iconEdit" />
            </template>
            <ipub-tooltip>
              <div slot="title">Delete</div>
              <ipub-icon type="iconDelete"
                         @click="del(index)" />
            </ipub-tooltip>
          </template>
        </ipub-table>
        <ipub-button type="primary"
                     icon="iconAdd"
                     @click="addNewAnswer()"
                     style="width:180px"
                     plain>Add New Answer</ipub-button>
      </ipub-form-item>
    </ipub-form>
    <div class="btns">
      <ipub-button plain
                   style="width:150px"
                   @click="
          () => {
            $router.back(-1)
          }
        "
                   type="primary">Cancel</ipub-button>
      <ipub-button style="width:150px;"
                   @click="submit()"
                   type="primary">Save</ipub-button>
    </div>
    <Add ref="manage-questionnaire-add"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
